import { render, staticRenderFns } from "./screenFacturas.vue?vue&type=template&id=6cc9ac57"
import script from "./screenFacturas.vue?vue&type=script&lang=js"
export * from "./screenFacturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports